import { Form, InputGroup } from 'react-bootstrap';
import { Dropdown } from '@Components/Dropdown';
import { Size } from '@Components/designConstants';
import { CopyButton } from '@Components/CopyButton';

interface RouteUrlBuilderProps {
  ploverUrl: string;
  readOnly: boolean;
  domain: string;
  folderPath: string;
  ploverName: string;
  domains: { web_url: string }[];
  onDomainChange: (domain: string) => void;
  onFolderPathChange: (path: string) => void;
  onPloverNameChange: (name: string) => void;
}

export const RouteUrlBuilder = ({
  ploverUrl,
  readOnly,
  domain,
  folderPath,
  ploverName,
  domains,
  onDomainChange,
  onFolderPathChange,
  onPloverNameChange
}: RouteUrlBuilderProps) => (
  <div className='route-url-builder'>
    <div className='route-url-preview'>
      <span className='route-url'>{ploverUrl}</span>
      <CopyButton text={ploverUrl} tooltipLabel='Copy URL to Clipboard' />
    </div>
    <p>
      <br />
      Path must start and end with / character. If a folder does not exist it would be created.
      Example: /pages/
    </p>
    <div className='route-url-inputs'>
      <InputGroup size='lg'>
        <div className='route-domain' data-testid='route-domain'>
          <Dropdown
            size={Size.LG}
            searchable
            value={domain || null}
            disabled={readOnly}
            placeholder='Domain'
            options={domains.map(({ web_url }) =>
              web_url === 'plover.insiderenvy.com'
                ? { value: 's.insiderenvy.com', label: 's.insiderenvy.com' }
                : { value: web_url, label: web_url }
            )}
            onChange={value => value && onDomainChange(value)}
          />
        </div>
        <Form.Control
          className={readOnly ? 'route-path disable' : 'route-path enable'}
          value={folderPath || ''}
          disabled={readOnly}
          type='text'
          placeholder='Path'
          onChange={e => onFolderPathChange(e.target.value)}
        />
        <Form.Control
          className={readOnly ? 'route-name disable' : 'route-name enable'}
          value={ploverName || ''}
          disabled={readOnly}
          type='text'
          placeholder='Route Name'
          onChange={e => onPloverNameChange(e.target.value)}
        />
      </InputGroup>
    </div>
  </div>
);
